module.exports = __webpack_public_path__ + "static/media/v20_14.773764cd.png";